import { helper } from '@ember/component/helper';
import { sanitizeUrl } from '@intercom/pulse/lib/sanitize';

export default helper(function _sanitizeUrl([unsafe, ..._rest]) {
  return sanitizeUrl(unsafe);
});
